import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import React from 'react';
import applicationSettings from '../../../Core/Settings/ApplicationSettings';

const oktaAuth = new OktaAuth({
    ...applicationSettings.okta,
    devMode: applicationSettings.isDevelopmentLike,
    scopes: ['email', 'profile', 'openid', 'offline_access'],
    tokenManager: {
        autoRenew: true,
        autoRemove: true,
        secure: true,
        storage: 'localStorage',
        expireEarlySeconds: 300,
    },
});

const OktaSecurity = ({ children }: React.PropsWithChildren<{}>) => {
    const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
        window.location.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    };

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            {children}
        </Security>
    );
};

export default OktaSecurity;
